import React from "react";
import Header from "@/components/Header";
import ChatPanel, { SorenMark } from "@/components/ChatPanel";
import LiveStakingRates from "@/components/LiveStakingRates";
import { Bot, GitBranch, Calculator, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

const TOPICS = [
  { title: "The whole flow",      sub: "17 nodes from invest → cash out → bank",   to: "/flow",       icon: <GitBranch size={14} /> },
  { title: "Calculator",          sub: "Hashrate vs Buy CA, risk scenarios",        to: "/calculator", icon: <Calculator size={14} /> },
];

export default function Ask() {
  return (
    <div className="min-h-screen pb-16">
      <Header variant="public" />

      <section className="px-6 md:px-10 pt-12 pb-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="pill mb-4"><span className="dot" /> Søren · the BotChainCP bot · Claude Haiku · trained on every CaryPact doc</div>
          <h1 className="font-display text-4xl md:text-5xl font-semibold leading-[1.05] tracking-tight flex flex-wrap items-center gap-x-4 gap-y-2">
            <SorenMark size={52} />
            <span>Hi, I&rsquo;m <span className="gradient-text">Søren</span> — ask me anything about CaryPact, BOT Chain, or your $1k.</span>
          </h1>
          <p className="text-base text-ink-2 max-w-2xl mt-3">
            I&rsquo;m the bot in the logo, and I know the full setup, every formula in the one-pager, all 10 VIP tiers, the 5 staking plans, and the cash-out path. Math questions get math answers. Risk questions get honest answers. Anything that needs a human, I&rsquo;ll pass to the team.
          </p>
        </div>
      </section>

      <section className="px-6 md:px-10">
        <div className="max-w-[1200px] mx-auto grid lg:grid-cols-[1fr_280px] gap-6">
          {/* Chat */}
          <div className="glass-strong overflow-hidden" style={{ borderRadius: 22, height: "calc(100vh - 320px)", minHeight: 520 }} data-testid="ask-chat-wrap">
            <ChatPanel />
          </div>

          {/* Sidebar */}
          <aside className="space-y-3">
            <LiveStakingRates />

            <div className="glass-strong p-4">
              <div className="flex items-center gap-2 mb-2">
                <Bot size={14} className="text-[#4060FF]" />
                <h3 className="font-display text-sm font-semibold tracking-tight">What Søren can help with</h3>
              </div>
              <ul className="space-y-1.5 text-xs text-ink-2">
                <li>• Setup walkthroughs (any step)</li>
                <li>• "What does V5 require?" rank math</li>
                <li>• "What is my $X likely to do in 12 months?"</li>
                <li>• Risk scenario sanity-checks</li>
                <li>• Cash-out path debugging</li>
                <li>• Common error messages</li>
              </ul>
            </div>

            <div className="glass-strong p-4">
              <div className="flex items-center gap-2 mb-2">
                <ShieldCheck size={14} style={{ color: "#00C853" }} />
                <h3 className="font-display text-sm font-semibold tracking-tight">Where he stops</h3>
              </div>
              <p className="text-[11px] text-ink-2 leading-relaxed">
                Søren is an AI, and he&rsquo;ll say so. He never asks for your seed phrase, never moves money, and never gives financial advice. When a figure looks wrong or a decision needs a person, use <b>Message admin</b> in the chat bubble or book a call.
              </p>
            </div>

            <div className="glass-strong p-4">
              <div className="text-[10px] uppercase tracking-wider font-mono text-ink-3 mb-2">Or browse by topic</div>
              <div className="space-y-2">
                {TOPICS.map((t) => (
                  <Link to={t.to} key={t.title} className="flex items-center gap-3 p-2.5 rounded-xl bg-white/60 hover:bg-white transition-colors" data-testid={`ask-topic-${t.to.replace('/', '')}`}>
                    <div className="w-7 h-7 rounded-lg flex items-center justify-center text-white" style={{ background: "linear-gradient(135deg, #4060FF, #6B4FFF)" }}>
                      {t.icon}
                    </div>
                    <div className="leading-tight">
                      <div className="font-display text-xs font-semibold tracking-tight">{t.title}</div>
                      <div className="text-[10px] text-ink-3">{t.sub}</div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>

            <div className="glass-strong p-4" style={{ background: "linear-gradient(135deg, rgba(64,96,255,0.05), rgba(236,72,153,0.05))" }}>
              <div className="text-[10px] uppercase tracking-wider font-mono text-ink-3 mb-1">Privacy</div>
              <p className="text-[11px] text-ink-2 leading-snug">
                Your chat is stored per browser session so you can pick up where you left off. We don't share it. Click the reset icon in the chat header to wipe history.
              </p>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}
